import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { navigate('/'); return; }

    api.get('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        if (res.data.success) {
          login(token, res.data.user, res.data.permissions);
          navigate('/home');
        } else {
          navigate('/?auth_error=Authentication+failed');
        }
      })
      .catch(() => navigate('/?auth_error=Authentication+failed'));
  }, []); // eslint-disable-line

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div className="spinner-border" style={{ color: '#17a2b8', width: 48, height: 48 }} />
        <p className="mt-3 text-muted">Completing sign-in…</p>
      </div>
    </div>
  );
}
